import styled, { css } from 'styled-components'

import { ButtonUnstyled } from 'components/Button'
import { truncateStyles } from 'components/Truncate'

import { ReactComponent as Ellipsis } from 'icons/ellipsis-16.svg'
import { breakpoint } from 'utils'

export const EllipsisIcon = styled(Ellipsis)`
  width: 16px;
  height: 16px;
`

export const DropdownAction = styled(ButtonUnstyled)`
  display: inline-flex;
  color: currentColor;

  height: 32px;

  justify-content: center;
  align-items: center;

  border-radius: ${({ theme }) => theme.radii.large};

  :hover,
  :focus,
  :focus-within {
    background-color: ${({ theme }) => theme.colors.background.tertiary[1]};
  }
`

export const ActionWrapper = styled.div`
  /* Fix positioning issue with dropdown in Safari */
  position: relative;

  opacity: 0;
  width: 0;

  margin-left: auto;
  margin-right: 0;

  transition: ${({ theme: { transitions } }) =>
    css`
      opacity ${transitions.duration[2]} ${transitions.timing.easeInOut},
      width ${transitions.duration[2]} ${transitions.timing.easeInOut};
    `};
`

export const Icon = styled.svg`
  width: 16px;
  height: 16px;
  margin-right: 12px;
  flex-shrink: 0;

  /* This color should be "Light/colors.foreground.secondary.4" but given the icon composition */
  /* Opacity needs to be applied to the whole object */
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  opacity: 0.55;

  pointer-events: none;
`

const hoverStyle = css`
  background-color: ${({ theme }) => theme.colors.background.tertiary[1]};
  color: ${({ theme }) => theme.colors.text.dark.primary};

  ${ActionWrapper} {
    opacity: 1;
  }

  ${ActionWrapper} {
    width: 40px;
  }

  ${DropdownAction} {
    width: 40px;
  }

  /* Fix the hover color of the icon */
  ${Icon} {
    color: ${({ theme }) => theme.colors.foreground.secondary[1]};
    opacity: 1;
  }
`

export const menuLinkStyles = css`
  width: 100%;
  height: 40px;

  display: inline-flex;
  align-items: center;

  background-color: transparent;

  padding: 8px 0px 8px 12px;
  border-radius: 5px;

  font-weight: ${({ theme }) => theme.fontWeights.regular};
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  line-height: 1.2;

  color: ${({ theme }) => theme.colors.text.dark.base};

  transition: none;

  ${breakpoint('sm')`
    height: 32px;
  `}

  ${ActionWrapper} {
    color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  }

  @media (hover: none) {
    ${ActionWrapper} {
      opacity: 1;
      width: 40px;
    }
  }

  :hover,
  :focus,
  :focus-within {
    ${hoverStyle};
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.primaryTint[10]};
    color: ${({ theme }) => theme.colors.primaryTint[100]};

    ${Icon} {
      opacity: 1;
    }

    ${Icon}, ${ActionWrapper} {
      color: ${({ theme }) => theme.colors.primaryTint[100]};
    }
  }
`

export const Text = styled.span`
  ${truncateStyles};
  padding-right: 4px;

  /* Aligns the label with the icon */
  position: relative;
  top: 1px;

  pointer-events: none;
`

interface MenuLinkProps {
  $forceHover?: boolean
}

export const MenuLink = styled.div<MenuLinkProps>`
  overflow: hidden;

  ${menuLinkStyles};
  ${({ $forceHover }) => $forceHover && hoverStyle};
`
